module.exports = __webpack_public_path__ + "img/photo-album-test-01.97a6d13c.png";